// --- isEmptyString

export default function isEmptyString ( str ) {
    return !str
        || str.replace( /\s/g, "" ) === ""
}